import styled from '@emotion/styled';
import { Text, SmallText } from 'ds/components/typography';

export const Container = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin-bottom: ${({ theme }) => theme.spacing(8)};
  margin-top: ${({ theme }) => theme.spacing(5)};
`;

export const MetricItem = styled.div`
  display: flex;
  align-items: center;
  width: calc(100% / 3);

  ${({ theme }) => theme.media.showAt({ from: 2 })`
    :nth-of-type(n + 4){
      margin-top: ${theme.spacing(4)};
    }
  `}

  ${({ theme }) => theme.media.showAt({ at: 1 })`
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    width: calc(50%);

    :nth-of-type(n + 3){
      margin-top: ${theme.spacing(4)};
    }

    svg {
      margin-bottom: ${theme.spacing(1)};
    }
  `}
`;

export const MetricText = styled.div`
  display: flex;
  flex-flow: column nowrap;
  align-items: flex-start;
  justify-content: center;
  margin: 0;

  ${({ theme }) => theme.media.showAt({ from: 2 })`
    ${`margin-${theme.isRTL ? 'right' : 'left'}: ${theme.spacing(2)}`}
  `}
`;

export const MetricValue = styled(Text)`
  letter-spacing: 0.3px;
  color: ${({ theme }) => theme.colors.neutrals.grey1};
  text-transform: capitalize;
`;

export const LinesWrapper = styled.div`
  display: flex;
  ${({ theme }) => `
    transform: translateX(-${theme.spacing(0.25)});
    margin-bottom: ${theme.spacing(0.5)};
  `}
`;

export const MetricDescription = styled(SmallText)`
  display: flex;
  color: ${({ theme }) => theme.colors.neutrals.grey3};
  flex-flow: row nowrap;
  align-items: center;

  svg {
    position: relative;
    top: 2px;
    ${({ theme }) => `margin-${theme.isRTL ? 'right' : 'left'} : ${theme.spacing(.5)}`}
  }
`;
